import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Paper,
  Box,
  Button,
  Grid,
  TableCell,
  TableRow
} from '@material-ui/core';
import {
  ListTableCell,
  ListTableHeaderCell,
  ListTableRow
} from '../../../atoms/Table';
import { useStyles } from './useStyles';
import { DeleteButton, EditButton } from '../../../atoms/Button';
import { useHooks } from './useHooks';
import PaginationComponent from '../../../PaginationComponent';
import {
  SEARCH_STATUS_VALUES,
  SITE_TASK_STATUSES
} from '../../../../const/TaskConst';
import { SiteTaskHistoryModal } from '../../../parts/task/TaskHistoryModal';
import { SiteTaskAddModal } from '../../../parts/task/TaskAddModal';
import { SiteTaskEditModal } from '../../../parts/task/TaskEditModal';
import { SiteTaskDeleteModal } from '../../../parts/task/TaskDeleteModal';
import {
  getSiteTaskStatusName,
  getSiteTaskSearchStatusName
} from '../../../../utils/constLabel';
import { SITE_PROCESS_DISPLAY_LIMIT_LIST } from '../../../../const/ProcessConst';
import { DEFAULT_MESSAGE_NO_DATA } from '../../../../const/Const';
import { ChangeEvent } from 'react';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import LoadingIcon from '../../../atoms/LoadingIcon';
import LoadingIconClear from '../../../atoms/LoadingIconClear';
import { BasicSelect } from '../../input/BasicSelect';
import { useContext } from 'react';
import { AuthInfoContext } from '../../../../AuthContextProvider';
import { ROLE } from '../../../../const/Const';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

type TProps = {
  constructId: number;
  siteProcessId?: number;
  viewAlert?: boolean;
};

export const SiteTaskListView: React.FC<TProps> = (props: TProps) => {
  const { constructId, siteProcessId, viewAlert } = props;

  const {
    displayLimit,
    pageCount,
    currentPage,
    siteTaskList,
    siteProcessList,
    userList,
    searchSiteProcessId,
    searchUserId,
    searchStatus,
    isOpenSiteTaskAdd,
    isOpenSiteTaskEdit,
    isOpenSiteTaskDelete,
    isOpenSiteTaskHistory,
    editSiteTaskId,
    deleteSiteTaskId,
    setCurrentPage,
    setIsOpenSiteTaskAdd,
    setIsOpenSiteTaskEdit,
    setIsOpenSiteTaskDelete,
    setIsOpenSiteTaskHistory,
    setEditSiteTaskId,
    setDeleteSiteTaskId,
    handleOnClickHistory,
    handleChangeSearchSiteProcess,
    handleChangeSearchUser,
    handleChangeSearchStatus,
    handleChangeDisplayLimit,
    reRenderSiteTaskData,
    handleChangeStatus,
    isLoading,
    isMovingPage
  } = useHooks(constructId, siteProcessId, viewAlert);

  const classes = useStyles();
  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);

  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <>
      {!isLoading && isMovingPage && (
        <div className={classes.loadingIconClearWrapper}>
          <LoadingIconClear />
        </div>
      )}
      <Box className={classes.listContainer}>
        {/* 画面サイズによってスマホ表示に切り替え */}
        {isSmDown ? (
          <Grid
            container
            className={`${classes.gridContainerPadding} ${classes.searchItemConteiner}`}
          >
            <Grid item xs={9} className={classes.flexWrap}>
              {/* 工程 セレクトボックス */}
              <Box
                className={`${classes.selectBoxContainer} ${classes.searchItem}`}
              >
                <BasicSelect
                  className={`${classes.selectBox} ${classes.constructInput}`}
                  value={searchSiteProcessId}
                  onChange={handleChangeSearchSiteProcess}
                  disableUnderline
                >
                  {siteProcessList.length > 0 &&
                    siteProcessList.map(siteProcess => (
                      <option key={siteProcess.value} value={siteProcess.value}>
                        {siteProcess.label}
                      </option>
                    ))}
                </BasicSelect>
              </Box>

              {/* 担当者 セレクトボックス */}
              <Box
                className={`${classes.selectBoxContainer} ${classes.searchItem}`}
              >
                <BasicSelect
                  className={`${classes.selectBox} ${classes.asigneeInput}`}
                  value={searchUserId}
                  onChange={handleChangeSearchUser}
                  disableUnderline
                >
                  {userList.length > 0 &&
                    userList.map(user => (
                      <option key={user.value} value={user.value}>
                        {user.label}
                      </option>
                    ))}
                </BasicSelect>
              </Box>

              {/* ステータス セレクトボックス */}
              <Box
                className={`${classes.selectBoxContainer} ${classes.searchItem}`}
              >
                <BasicSelect
                  className={classes.selectBox}
                  value={searchStatus}
                  onChange={handleChangeSearchStatus}
                  disableUnderline
                >
                  {SEARCH_STATUS_VALUES.map(value => (
                    <option value={value} key={value}>
                      {getSiteTaskSearchStatusName(value)}
                    </option>
                  ))}
                </BasicSelect>
              </Box>

              {/* 表示数 セレクトボックス */}
              <Box
                className={`${classes.selectBoxContainer} ${classes.searchItem}`}
              >
                <Box style={{ marginRight: 10 }}>表示件数</Box>
                <BasicSelect
                  className={classes.selectBox}
                  value={displayLimit}
                  onChange={handleChangeDisplayLimit}
                  disableUnderline
                >
                  {SITE_PROCESS_DISPLAY_LIMIT_LIST.map(display_limit => (
                    <option value={display_limit} key={display_limit}>
                      {display_limit}件
                    </option>
                  ))}
                </BasicSelect>
              </Box>
            </Grid>

            <Grid
              item
              xs={3}
              className={`${classes.flexEnd} ${classes.flexWrap} ${classes.rightsideButtonContainer}`}
            >
              <Button
                className={classes.underLine}
                onClick={handleOnClickHistory}
                style={{
                  marginRight: 15
                }}
              >
                更新履歴
              </Button>
              {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                <EditButton
                  onClick={() => {
                    setIsOpenSiteTaskAdd(true);
                  }}
                >
                  タスクの追加
                </EditButton>
              )}
            </Grid>
          </Grid>
        ) : (
          <Grid
            container
            xs={12}
            className={classes.gridContainerPadding}
            spacing={1}
            justify='center'
          >
            {/* 工程 セレクトボックス */}
            <Grid container item xs={12}>
              <Grid item xs={12}>
                <BasicSelect
                  className={`${classes.selectBox}`}
                  value={searchSiteProcessId}
                  onChange={handleChangeSearchSiteProcess}
                  disableUnderline
                >
                  {siteProcessList.length > 0 &&
                    siteProcessList.map(siteProcess => (
                      <option key={siteProcess.value} value={siteProcess.value}>
                        {siteProcess.label}
                      </option>
                    ))}
                </BasicSelect>
              </Grid>
            </Grid>
            <Grid container item xs={12}>
              {/* 担当者 セレクトボックス */}
              <Grid item xs={12}>
                <BasicSelect
                  className={`${classes.selectBox}`}
                  value={searchUserId}
                  onChange={handleChangeSearchUser}
                  disableUnderline
                >
                  {userList.length > 0 &&
                    userList.map(user => (
                      <option key={user.value} value={user.value}>
                        {user.label}
                      </option>
                    ))}
                </BasicSelect>
              </Grid>
            </Grid>

            <Grid container item xs={8}>
              {/* ステータス セレクトボックス */}
              <Grid item xs={12}>
                <BasicSelect
                  className={classes.selectBox}
                  value={searchStatus}
                  onChange={handleChangeSearchStatus}
                  disableUnderline
                >
                  {SEARCH_STATUS_VALUES.map(value => (
                    <option value={value} key={value}>
                      {getSiteTaskSearchStatusName(value)}
                    </option>
                  ))}
                </BasicSelect>
              </Grid>
            </Grid>

            <Grid container item xs={4}>
              {/* 表示数 セレクトボックス */}
              <Grid item xs={12}>
                <BasicSelect
                  className={classes.selectBox}
                  value={displayLimit}
                  onChange={handleChangeDisplayLimit}
                  disableUnderline
                >
                  {SITE_PROCESS_DISPLAY_LIMIT_LIST.map(display_limit => (
                    <option value={display_limit} key={display_limit}>
                      {display_limit}件
                    </option>
                  ))}
                </BasicSelect>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              className={`${classes.flexEnd} ${classes.flexWrap} ${classes.rightsideButtonContainer}`}
            >
              <Button
                className={classes.underLine}
                onClick={handleOnClickHistory}
                style={{
                  marginRight: 15
                }}
              >
                更新履歴
              </Button>
              <CreateNewFolderIcon
                onClick={() => {
                  setIsOpenSiteTaskAdd(true);
                }}
                className={classes.createNewFolderIcon}
              />
            </Grid>
          </Grid>
        )}
        {/* /レスポンシブレイアウト */}

        {isLoading && (
          <div className={classes.loadingContainer}>
            <LoadingIcon />
          </div>
        )}
        {!isLoading && (
          <>
            <TableContainer
              component={Paper}
              className={classes.tableContainer}
            >
              <Table>
                <TableHead>
                  <ListTableHeaderCell className={classes.headerCellLarge}>
                    タスク
                  </ListTableHeaderCell>
                  <ListTableHeaderCell className={classes.headerCellLarge}>
                    担当
                  </ListTableHeaderCell>
                  <ListTableHeaderCell className={classes.headerCellLarge}>
                    工程
                  </ListTableHeaderCell>
                  <ListTableHeaderCell
                    className={`${classes.headerCellMedium} ${classes.textAlignCenter}`}
                  >
                    期限
                  </ListTableHeaderCell>
                  <ListTableHeaderCell
                    className={`${classes.headerCellMedium} ${classes.textAlignCenter}`}
                  >
                    ステータス
                  </ListTableHeaderCell>
                  <ListTableHeaderCell
                    className={`${classes.headerCellMedium} ${classes.textAlignCenter}`}
                  >
                    完了日
                  </ListTableHeaderCell>
                  {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                    <ListTableHeaderCell></ListTableHeaderCell>
                  )}
                </TableHead>
                <TableBody>
                  {siteTaskList &&
                    siteTaskList.map(siteTask => {
                      return (
                        <ListTableRow key={siteTask.id}>
                          <ListTableCell className={classes.tebaleCellText}>
                            {siteTask.site_task_name}
                          </ListTableCell>
                          <ListTableCell className={classes.tebaleCellText}>
                            {siteTask.charge_user?.name || '--'}
                          </ListTableCell>
                          <ListTableCell className={classes.tebaleCellText}>
                            {siteTask.site_process?.site_process_name}
                          </ListTableCell>
                          <ListTableCell className={classes.textAlignCenter}>
                            {siteTask.planned_end_date || '--'}
                          </ListTableCell>
                          <ListTableCell className={classes.textAlignCenter}>
                            <BasicSelect
                              className={`${classes.selectBox} ${classes.selectBoxInRow}`}
                              value={siteTask.status}
                              onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                                handleChangeStatus(e, siteTask.id);
                              }}
                              disableUnderline
                            >
                              {SITE_TASK_STATUSES.map(value => (
                                <option value={value} key={value}>
                                  {getSiteTaskStatusName(value)}
                                </option>
                              ))}
                            </BasicSelect>
                          </ListTableCell>
                          <ListTableCell className={classes.textAlignCenter}>
                            {siteTask.actual_end_date || '--'}
                          </ListTableCell>
                          {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                            <ListTableCell>
                              <div className={classes.listTableButtonContainer}>
                                <EditButton
                                  onClick={() => {
                                    setEditSiteTaskId(siteTask.id);
                                    setIsOpenSiteTaskEdit(true);
                                  }}
                                >
                                  編集
                                </EditButton>
                                <DeleteButton
                                  onClick={() => {
                                    setDeleteSiteTaskId(siteTask.id);
                                    setIsOpenSiteTaskDelete(true);
                                  }}
                                >
                                  削除
                                </DeleteButton>
                              </div>
                            </ListTableCell>
                          )}
                        </ListTableRow>
                      );
                    })}
                  {(!siteTaskList || siteTaskList.length === 0) && (
                    <>
                      <TableRow>
                        <TableCell
                          colSpan={6}
                          className={classes.centerMessage}
                        >
                          {DEFAULT_MESSAGE_NO_DATA}
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {siteTaskList && siteTaskList.length > 0 && (
              <Box className={classes.pagenationContainer}>
                <PaginationComponent
                  page={currentPage}
                  pageCount={pageCount}
                  setCurrentPage={setCurrentPage}
                />
              </Box>
            )}
          </>
        )}

        {/* タスク追加モーダル */}
        <SiteTaskAddModal
          isOpen={isOpenSiteTaskAdd}
          setIsOpen={setIsOpenSiteTaskAdd}
          afterSubmit={reRenderSiteTaskData}
          constructId={constructId}
          siteProcessId={searchSiteProcessId}
        />

        {/* タスク編集モーダル */}
        <SiteTaskEditModal
          isOpen={isOpenSiteTaskEdit}
          setIsOpen={setIsOpenSiteTaskEdit}
          afterUpdate={reRenderSiteTaskData}
          constructId={constructId}
          siteTaskId={editSiteTaskId}
          afterDelete={reRenderSiteTaskData} //削除ボタン用
        />

        {/* タスク削除モーダル */}
        <SiteTaskDeleteModal
          isOpen={isOpenSiteTaskDelete}
          setIsOpen={setIsOpenSiteTaskDelete}
          afterSubmit={reRenderSiteTaskData}
          siteTaskId={deleteSiteTaskId}
        />

        {/* タスク更新履歴モーダル */}
        <SiteTaskHistoryModal
          constructId={constructId}
          isOpen={isOpenSiteTaskHistory}
          setIsOpen={setIsOpenSiteTaskHistory}
        />
      </Box>
    </>
  );
};
